import { render, staticRenderFns } from "./VNoData.vue?vue&type=template&id=2f772b9f&scoped=true&"
import script from "./VNoData.vue?vue&type=script&lang=ts&"
export * from "./VNoData.vue?vue&type=script&lang=ts&"
import style0 from "./VNoData.vue?vue&type=style&index=0&id=2f772b9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f772b9f",
  null
  
)

export default component.exports